import { create } from "zustand";

const ID_KEY = "odos_merchant_id";
const NAME_KEY = "odos_merchant_name";

// Read the saved session synchronously so the first render already knows the merchant
// (otherwise a hard refresh on /store-profile redirected to /login → dashboard).
function readStoredSession() {
  try {
    const raw = localStorage.getItem(ID_KEY);
    const id = raw != null && raw !== "" ? Number(raw) : null;
    return {
      merchantId: Number.isFinite(id) ? id : null,
      merchantName: localStorage.getItem(NAME_KEY) || null,
    };
  } catch (_) {
    return { merchantId: null, merchantName: null };
  }
}

export const useMerchantStore = create((set) => ({
  ...readStoredSession(),
  setMerchantId: (merchantId) => set({ merchantId }),
  setMerchantName: (merchantName) => set({ merchantName }),
  setSession: ({ merchantId, merchantName }) => {
    if (merchantId != null) {
      try {
        localStorage.setItem(ID_KEY, String(merchantId));
      } catch (_) {}
    }
    if (merchantName != null) {
      try {
        localStorage.setItem(NAME_KEY, merchantName);
      } catch (_) {}
    }
    set({ merchantId, merchantName });
  },
  clearSession: () => {
    try {
      localStorage.removeItem(ID_KEY);
      localStorage.removeItem(NAME_KEY);
    } catch (_) {}
    set({ merchantId: null, merchantName: null });
  },
}));

export function hydrateMerchantSessionFromStorage() {
  try {
    const raw = localStorage.getItem(ID_KEY);
    const name = localStorage.getItem(NAME_KEY);
    const id = raw != null && raw !== "" ? Number(raw) : null;
    if (Number.isFinite(id)) {
      useMerchantStore.getState().setMerchantId(id);
    }
    if (name) {
      useMerchantStore.getState().setMerchantName(name);
    }
  } catch (_) {}
}
